import React, { useState } from "react";
import Image from "next/image";
import { useRouter } from "next/router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect } from "react";
import {
  faSignOutAlt,
  faBars,
  faSearch,
  faChevronDown,
  faChevronUp,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { handleLogout } from "../../utils/utils";
import { apiGateway } from "../../utils/config";
import { ClickAwayListener } from "@mui/base";
import { Popper } from "@mui/material";
import { handleHamburgerClicked } from "../../utils/helperEventFunctions";
import { useSelector } from "react-redux";
import SearchBar from "../search-bar/search-bar.component";
import events from "../../events";
import Link from "next/link";
import styles from "./Header.module.scss";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import useStore from "../../store/UseStore";
import MobileSideNav from "../common/Navbar/MobileSideNav";

const seekhoAppPremiumIconURL =
  "https://images.seekhoapp.com/static/website/v2/plus_icon.png";

export default function Header(props) {
  const { webviewEvent } = props;
  const [openSearch, setOpenSearch] = useState(false);
  const [hydrated, setHydrated] = useState(false);
  // const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElSearch, setAnchorElSearch] = useState(null);
  const [open, setOpen] = useState(props.openLogin || false);
  const [anchorElPopper, setAnchorElPopper] = React.useState(null);
  const [showSideMenu, setShowSideMenu] = useState(false);
  const [searchInput, setSearchInput] = useState(
    props?.router?.query?.query || ""
  );
  const [searchedSeries, setSearchedSeries] = useState([]);
  const [categories, setCategories] = useState([]);
  const { setOpenAllCategories } = useStore();
  const currentUser = useSelector((state) => state?.currentUser?.currentUser);
  const firebase_uid = useSelector((state) => state.currentUser?.firebaseUID);
  const isUserPremium = currentUser?.is_premium;
  const openPopper = Boolean(anchorElPopper);
  const id = openPopper ? "simple-popper" : undefined;
  const openPopperSearch = Boolean(anchorElSearch);
  const idSearch = openPopperSearch ? "simple-popper-search" : undefined;
  const axiosPrivate = useAxiosPrivate();
  const router = useRouter();

  const handleGetCategories = async () => {
    try {
      const url = `${apiGateway}/api/v1/home/mixed-items/`;
      const response = await axiosPrivate.get(url);
      const apiCategories = response?.data?.mixed_items || [];
      const updatedCategories = [
        ...apiCategories,
        { id: "explore", title: "Explore More", slug: "" },
      ];
      setCategories(updatedCategories);
    } catch (error) {
      setCategories([]);
      console.error("Error", error);
    }
  };

  const handlePoperCategory = (event) => {
    handleGetCategories();
    setAnchorElPopper(anchorElPopper ? null : event.currentTarget);
  };

  const handlePoperSearch = (event) => {
    setAnchorElSearch(anchorElSearch ? null : event.currentTarget);
  };

  const handleOpen = () => {
    window.dataLayer = window.dataLayer || [];
    const eventParams = {
      firebase_uid,
      date_time: new Date(),
    };
    if (webviewEvent) {
      eventParams.packageName = webviewEvent?.packageName;
      eventParams.userAgent = webviewEvent?.userAgent;
      eventParams.mobile = webviewEvent?.mobile;
      eventParams.webview = true;
    }
    window.dataLayer.push({
      event: events.web_login_clicked,
      ...eventParams,
    });
    props?.router.push("/login");
  };

  const toggleSideMenu = () => {
    if (setOpenAllCategories) setOpenAllCategories(false);
    setShowSideMenu((prev) => !prev);
    handleHamburgerClicked({
      firebase_uid,
      screen: window.location.href,
      webviewEvent,
    });
  };

  const onSelectSearched = (series) => {
    setSearchedSeries([]);
    // if (series.is_premium && !globalState?.userFullInformation?.user.is_premium) {
    //   props?.router?.push("/premium/");
    // } else {
    props?.router?.push(`/video/${series.slug}`);
    // }
  };

  const onSearchInputChange = (e) => {
    const val = e.target.value;
    setSearchInput(val);
    const isMobileScreen = window.screen.width < 560;
    if (val === "") {
      props?.router.push("/app");
    }
    if (isMobileScreen) {
      props?.router.push(`/search?search_query=${val}`, undefined, {
        shallow: true,
      });
    }
    searchSeries(val);
  };

  const handleKeyEvent = (e) => {
    if (e.key === "Enter") {
      setSearchedSeries([]);
      handlePoperSearch(e);
      setOpenSearch(false);
      setSearchInput("");
      props?.router.push(`/search?search_query=${searchInput}`, undefined, {
        shallow: true,
      });
    }
  };

  const searchSeries = async (seriesName) => {
    const isMobileScreen = window.screen.width < 560;
    if (seriesName && !isMobileScreen) {
      try {
        const url = `${apiGateway}/api/v1/search/results/?q=${seriesName}&type=series`;
        const response = await axiosPrivate.get(url);
        console.log(response);
        const searchedSeriesData = response.data;
        const maxSeriesCount = isMobileScreen ? 5 : 10;
        setSearchedSeries(
          searchedSeriesData?.items.slice(0, maxSeriesCount) || []
        );
      } catch (error) {
        console.error("Error searching series:", error);
      }
    }
  };

  const getSlugValue = (key) => {
    let filteredCategory = [];
    if (categories?.length > 0) {
      filteredCategory = categories.filter(({ slug }) => slug === key);
    }
    return filteredCategory[0]?.title ?? "Category";
  };

  useEffect(() => {
    if (props.openLogin !== open) {
      setOpen(props.openLogin);
    }
  }, [props.openLogin]);

  useEffect(() => {
    setHydrated(true);
  }, []);

  if (!hydrated) return null;

  return (
    <section>
      {/* {isUserPremium && showIphoneBanner ? (
        <div className="lg:!hidden">
          <IPhoneTopBanner />
        </div>
      ) : null} */}
      <div className={styles.header}>
        <div className={styles.sideNav}>
          <MobileSideNav
            openDrawer={showSideMenu}
            setOpenDrawer={setShowSideMenu}
          />
        </div>

        <div className={styles.itemsCenter}>
          <div className={styles.brandIcon}>
            {isUserPremium ? (
              <img
                alt="seekhoapp-logo"
                onClick={() => props?.router.push("/app")}
                src={seekhoAppPremiumIconURL}
              />
            ) : (
              <Image
                loading="lazy"
                alt="seekhoapp-logo"
                onClick={() => props?.router.push("/")}
                src={require("../../public/assets/headerlogo.webp")}
                className={styles.brandIcon_image}
              />
            )}
          </div>
        </div>

        <div className={styles.tabs}>
          <span
            className={`${styles.tab}`}
            style={
              props?.router.pathname == "/"
                ? { color: "white", fontWeight: 500 }
                : {}
            }
          >
            <Link href="/app">Home</Link>
          </span>

          {/* <span className={`${styles.tab}`}>
          <Link href="/team">Team & Culture</Link>
        </span> */}

          <span className={`${styles.tab} ${styles.header_category}`}>
            <button
              onClick={(e) => handlePoperCategory(e)}
              className={styles.category_dropdown}
              style={{
                color:
                  getSlugValue(props?.router?.query?.categorySlug) !==
                    "Category" && "white",
              }}
            >
              {getSlugValue(props?.router?.query?.categorySlug)}{" "}
              <FontAwesomeIcon
                icon={openPopper ? faChevronUp : faChevronDown}
              />
            </button>
            <Popper
              id={id}
              open={openPopper}
              anchorEl={anchorElPopper}
              style={{ zIndex: 100, position: "relative" }}
            >
              <ClickAwayListener onClickAway={() => setAnchorElPopper(null)}>
                <div className={styles.categoryPopper}>
                  <div className={styles.categoryPopper_inner}>
                    {categories?.length > 0 &&
                      categories?.map((category, index) => {
                        return (
                          <Link
                            key={category.id}
                            href={`/category/${category.slug || ""}`}
                            scroll={false}
                          >
                            <div
                              className={styles.link_category}
                              onClick={() => setAnchorElPopper(null)}
                            >
                              <div
                                className={styles.category}
                                style={{
                                  borderLeftColor: category.color,
                                }}
                              >
                                <div
                                  className={` px-[3px] py-1 rounded-lg line-clamp-1  ${
                                    router?.query?.categorySlug ==
                                      category.slug ||
                                    router.pathname?.split("/")[1] ==
                                      category.slug
                                      ? "text-white hover:bg-white hover:!text-black"
                                      : " hover:bg-white hover:text-black"
                                  }`}
                                >
                                  {category.title}
                                </div>
                              </div>
                            </div>
                          </Link>
                        );
                      })}
                  </div>
                </div>
              </ClickAwayListener>
            </Popper>
          </span>

          <button className={styles.searchInput}>
            <div
              style={{ padding: 0, cursor: "pointer" }}
              onClick={(e) => {
                // setOpenSearch(!openSearch);
                handlePoperSearch(e);
              }}
            >
              <FontAwesomeIcon
                icon={!openPopperSearch ? faSearch : faTimes}
                style={{ fontSize: 24 }}
              />
            </div>
            <Popper
              id={idSearch}
              open={openPopperSearch}
              anchorEl={anchorElSearch}
              style={{ zIndex: 10000, position: "relative", marginTop: 20 }}
              className={styles.popper_search}
            >
              <ClickAwayListener
                onClickAway={(e) => {
                  e.preventDefault();
                  setAnchorElSearch(null);
                }}
                // eslint-disable-next-line react/no-children-prop
                children={
                  <div className={styles.search_absolute}>
                    <SearchBar
                      placeholder={"Search for Series, Topic or Creator"}
                      value={searchInput}
                      onElementClick={onSelectSearched}
                      onChange={onSearchInputChange}
                      setOpenSearch={(e) => {
                        handlePoperSearch(e);
                        setOpenSearch(false);
                        setSearchInput("");
                      }}
                      searchedData={searchedSeries}
                      handleKeyEvent={handleKeyEvent}
                    />
                  </div>
                }
              />
            </Popper>
          </button>
          {currentUser?.id ? (
            <div
              className={styles.logout_tab}
              onClick={() => handleLogout({ axiosPrivate })}
            >
              Logout
              <FontAwesomeIcon icon={faSignOutAlt} className={styles.singout} />
            </div>
          ) : (
            <div className={styles.tabl}>
              <button onClick={handleOpen} className={styles.button_signup_cta}>
                Login
              </button>
            </div>
          )}
        </div>

        <div className={styles.menuIcon}>
          {/* {!userData?.phone && (
          <span
            className="text-white border text-[13px] px-2 py-1 rounded-lg"
            onClick={() => router.push("/login")}
          >
            Login
          </span>
        )} */}
          <FontAwesomeIcon
            icon={faBars}
            style={{ width: 26, height: 26 }}
            onClick={toggleSideMenu}
          ></FontAwesomeIcon>
        </div>
      </div>
    </section>
  );
}

export async function getServerSideProps(context) {
  const arr = context?.req?.headers?.referer?.toString()?.split("/");

  let source = null;
  if (arr === undefined) {
    source = "premium";
  } else if (arr[arr.length - 1] === "") {
    source = "home";
  } else if (arr.length <= 4) {
    source = arr[arr.length - 1];
  }
  return {
    props: {
      source,
    },
  };
}
